import {IMetricsSummary} from "../../../../utils/metrics/metricTypes";

export class NoticeMetricsSummary implements IMetricsSummary {
  id: string;
  title?: string;
  isImportant?: boolean;
  author?: string;
  publishDate?: string;
  readCount?: number;
  notificationDate?: string;
  isMultiVillage: boolean;
  hasAttachment: boolean;
  isAnnouncement?: boolean;

  get hasNotification(): boolean {
    return !!this.notificationDate;
  }

  villageIds?: string[];

  constructor(json: any) {
    this.id = json.id;
    this.villageIds = json.villageIds;

    this.title = json.title;
    this.isImportant = json.isImportant;
    this.author = json.author;
    this.publishDate = json.publishDate;
    this.readCount = json.readCount;
    this.notificationDate = json.notificationDate;
    this.isMultiVillage = json.isMultiVillage && json.isMultiVillage === true;
    this.hasAttachment = !!json.fileId;
    this.isAnnouncement = json.isAnnouncement;
  }
}
